export const environment = {
  production: false,
  // apiUrl: 'https://varanium.getvantage.co:3000/v1',
  apiUrl: 'https://uat-api-varanium.getvantage.co/v1',
  // apiUrl: 'http://localhost:4800/v1', //Local/
  // apiUrl: 'http://localhost:4800/v1',
  // apiUrl: 'http://localhost:3003/v1',
  EncryptKey: 'GetVantage#2019@&GetGrowth#2023@',
  EncryptIV: 'GetVantage#2019@&GetGrowth#2023@',
};
